import React from "react";
import { AlertTriangle, Clock } from "lucide-react";
import { PRIORITY_STYLES, etaColor } from "../lib/constants";

export function PriorityBadge({ value, testid, size = "sm" }) {
  const v = value || "Normal";
  const cfg = PRIORITY_STYLES[v] || PRIORITY_STYLES.Normal;
  const isUrgent = v === "Urgent" || v === "High";
  const sizing = size === "lg" ? "px-3 py-1 text-sm" : "px-2 py-0.5 text-[10px]";
  return (
    <span
      data-testid={testid || `priority-${v}`}
      className={`inline-flex items-center gap-1 font-bold uppercase tracking-wider rounded-sm ${sizing} ${cfg.pill}`}
    >
      {isUrgent && <AlertTriangle strokeWidth={3} className={size === "lg" ? "h-4 w-4" : "h-3 w-3"} />}
      {cfg.label}
    </span>
  );
}

export function EtaBadge({ etaText, etaIso, position, testid, size = "sm" }) {
  if (!etaText) return null;
  const color = etaColor(etaIso);
  const sizing = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2 py-1 text-xs";
  return (
    <div
      data-testid={testid || "eta-badge"}
      className={`inline-flex items-center gap-1.5 font-bold uppercase tracking-wide rounded-sm border-2 border-slate-200 bg-white ${color} ${sizing}`}
      title={etaIso ? `Estimated ready: ${new Date(etaIso).toLocaleString()}` : undefined}
    >
      <Clock strokeWidth={2.5} className={size === "lg" ? "h-4 w-4" : "h-3.5 w-3.5"} />
      <span className="font-display">{etaText}</span>
      {position !== undefined && position !== null && size === "lg" && (
        <span className="text-[10px] font-bold text-slate-500 normal-case">
          (#{position + 1} in queue)
        </span>
      )}
    </div>
  );
}
